import ErrorPage from "../ErrorPage";
import Login from "../login";
// import React from "react";
// import App from "./components/cm/App";
// import ClientListSearchv3 from "./components/cm/Dashboard/FullPages/ClientSearchFullv3";
// import CalendarFull from "./components/cm/Dashboard/FullPages/CalendarFull";
// import NonNetworkProvForm from "./components/cm/Dashboard/FullPages/NonNetProvForm";
// import AssignAppt from "./components/cm/Dashboard/FullPages/AssignAppt/AssignAppt";
// import FollowUpCalendar from "./components/cm/Dashboard/FullPages/ClientDetail/FollowUps/Calendar";
// import CaseManagerContact from "./components/cm/Dashboard/FullPages/CaseManagerContact";
// import ClientDetail from "./components/cm/Dashboard/FullPages/ClientDetail";
// import AddClientForm from "./components/cm/Dashboard/FullPages/ClientForm/AddClientForm";
// import SearchByMissedAppts from "./components/cm/Dashboard/FullPages/SearchByMissedAppts";
// import AnalyticsFullV2 from "./components/cm/Dashboard/FullPages/AnalyticsFullV2";
// import CreateLawfirm from "./components/cm/Dashboard/FullPages/CreateLawfirm";
// import ProviderClientSearch from "./components/cm/Dashboard/FullPages/ProviderClientSearch";
// import NeedsSupervisor from "./components/cm/Dashboard/FullPages/NeedsSupervisor";
// import OverarchingProvMap from "./components/cm/Dashboard/FullPages/OverarchingProvMap";
// import InNetworkProviders from "./components/cm/Dashboard/FullPages/InNetworkProviders";
// import ActionItems from "./components/cm/Dashboard/FullPages/ActionItems";
// import ActionItemCounts from "./components/cm/Dashboard/FullPages/ActionItems/ActionItemCounts";
// import Settlement from "./components/cm/Dashboard/FullPages/Settlement";
// import GlobalUserDash from "./components/cm/Dashboard/DashboardVersions/GlobalUserDash";
// import LiabilityRequestedList from "./components/cm/Dashboard/FullPages/LiabilityRequestedList";
// import LawfirmPropertyDamage from "./components/cm/Dashboard/FullPages/LawfirmPropertyDamage";
// import LawfirmPolicyLimit from "./components/cm/Dashboard/FullPages/LawfirmPolicyLimit";
// import LawfirmSortLiability from "./components/cm/Dashboard/FullPages/LawfirmSortByLiability";
// import LawfirmSortByReport from "./components/cm/Dashboard/FullPages/LawfirmSortByReport";
// import DocumentSearch from "./components/cm/Dashboard/FullPages/DocumentSearch";
// import ProviderMap from "./components/cm/Dashboard/FullPages/ProviderMap";
// import MyAccount from "./components/cm/Dashboard/FullPages/MyAccount";
// import UserProfile from "./components/cm/Dashboard/FullPages/UserManager/UserProfile";
// import UserProfileManager from "./components/cm/Dashboard/FullPages/UserManager/UserProfileManager";
// import NeedsAppointment from "./components/cm/Dashboard/FullPages/NeedsAppointment";
// import AddUserStandalone from "./components/cm/Dashboard/FullPages/UserManager/UserProfileManager/AddUserStandalone";
// import LogPhone from "./components/cm/Dashboard/FullPages/LogPhone";
// import LogSMS from "./components/cm/Dashboard/FullPages/LogSMS";
// import AccountabilityLog from "./components/cm/Dashboard/FullPages/AccountabilityLog";
// import CompletedNoBill from "./components/cm/Dashboard/FullPages/CompletedNoBill";
// import Reports from "./components/cm/Dashboard/FullPages/Reports";
// import ReportDetail from "./components/cm/Dashboard/FullPages/Reports/components/ReportsDetail/ReportDetail";
// import ProviderDetail from "./components/cm/Dashboard/FullPages/ProviderDetail";
// import ProviderManager from "./components/cm/Dashboard/FullPages/ProviderManager";
// import PasswordReset from "./components/cm/Dashboard/FullPages/ClientForm/PasswordReset";
// import ClientUploadDocument from "./components/cm/ClientUploadDocuments";
// import AppointmentConfirmation from "./components/cm/AppointmentConfirmation";
// import ErrorPage from "../ErrorPage";
// import {createBrowserRouter} from "react-router-dom";
//
// const routes = [
//   {index: true, element: <Login/>},
//   {
//     path: "/",
//     element: <App/>,
//     children: [
// {
//         path: "finance",
//         children: [
//           {
//             path: "cases", children: [
//               {path: "list", element: <GlobalUserDash/>},
//               {
//                 path: ":id", children: [
//                   {
//                     path: "details", element: <UserProfile/>,
//                   },
//                   {
//                     path: "details", element: <UserProfile/>,
//                   },
//                   {
//                     path: "expenses", element: <UserProfile/>,
//                   },
//                   {
//                     path: "payments", element: <UserProfile/>,
//                   },
//                   {
//                     path: "providers", element: <UserProfile/>,
//                   },
//                   {
//                     path: "documents", element: <UserProfile/>,
//                   },
//                 ]
//               }
//             ]
//           },
//         ],
//       },
//       {path: "pw-reset", element: <PasswordReset/>},
//       {path: "client-upload-documents", element: <ClientUploadDocument/>},
//       {path: "appointments-confirmation/:id", element: <AppointmentConfirmation/>},
//       {path: "*", element: <ErrorPage/>, errorElement: <ErrorPage/>},
//       {path: "dashboard", element: <GlobalUserDash/>},
//       {path: "search", element: <ClientListSearchv3/>},
//       {path: "provider-map", element: <ProviderMap/>},
//       {path: "appointment-calendar", element: <CalendarFull/>},
//       {path: "provider/:id", element: <ProviderDetail/>},
//       {path: "create-provider", element: <NonNetworkProvForm/>},
//       {path: "addappt", element: <AssignAppt/>},
//       {path: "callback-calendar", element: <FollowUpCalendar/>},
//       {path: "contact", element: <CaseManagerContact/>},
//       {path: "client-detail/:id", element: <ClientDetail/>},
//       {path: "my-account", element: <MyAccount/>},
//       {path: "profile/:id", element: <UserProfile/>},
//       {path: "add-client", element: <AddClientForm/>},
//       {path: "add-application-user", element: <AddUserStandalone/>},
//       {path: "missed-appts", element: <SearchByMissedAppts/>},
//       {path: "needs-appointment", element: <NeedsAppointment/>},
//       {path: "analytics", element: <AnalyticsFullV2/>},
//       {path: "create-law-firm", element: <CreateLawfirm/>},
//       {path: "provider-client-search", element: <ProviderClientSearch/>},
//       {path: "needs-supervisor", element: <NeedsSupervisor/>},
//       {path: "globalmap", element: <OverarchingProvMap/>},
//       {path: "in-network-providers", element: <InNetworkProviders/>},
//       {path: "action-items", element: <ActionItems/>},
//       {path: "action-item-counts", element: <ActionItemCounts/>},
//       {path: "settlement/:id", element: <Settlement/>},
//       {path: "liability-requested", element: <LiabilityRequestedList/>},
//       {path: "needs-property-damage", element: <LawfirmPropertyDamage/>},
//       {path: "needs-policy-limit", element: <LawfirmPolicyLimit/>},
//       {path: "liability-sort", element: <LawfirmSortLiability/>},
//       {path: "needs-police-report", element: <LawfirmSortByReport/>},
//       {path: "document-search", element: <DocumentSearch/>},
//       {path: "user-profiles", element: <UserProfileManager/>},
//       {path: "phone-log", element: <LogPhone/>},
//       {path: "sms-log", element: <LogSMS/>},
//       {path: "action-log", element: <AccountabilityLog/>},
//       {path: "completed-appointment-with-no-bill", element: <CompletedNoBill/>},
//       {path: "followup-calendar", element: <FollowUpCalendar/>},
//       {
//         path: "reports", children: [
//           {index: true, element: <Reports/>},
//           {path: ":id", element: <ReportDetail/>}
//         ]
//       },
//       {path: "providers", element: <ProviderManager/>},
//     ],
//   },
// ];
//
// export default createBrowserRouter(routes);

import { createBrowserRouter, Outlet } from "react-router-dom";
import App from "./components/cm/App";
import ErrorBoundary from "../ErrorBoundary";

const podModules = require.context("./pods", true, /route\.js$/);

const groupRoutesByHierarchy = () => {
  const routes = [];

  podModules.keys().forEach((key) => {
    // Remove the './pods' part and normalize the path.
    const pathParts = key
      .replace("./pods/", "") // Remove the base folder
      .replace(/\/route\.js$/, "") // Remove the file name
      .split("/"); // Split by directory slashes

    let currentLevel = routes;

    pathParts.forEach((part, index) => {
      // Filter out any empty strings or '.' routes
      if (part === "." || part === "") return;

      let existingPath = currentLevel.find((route) => route.path === part);

      if (!existingPath) {
        // If the route doesn't exist, create it
        existingPath = { path: part, children: [] };
        currentLevel.push(existingPath);
      }

      // If we're at the last part, add the module to it
      if (index === pathParts.length - 1) {
        existingPath.module = podModules(key).default; // Add the module here
      }

      // Move to the next level of children
      currentLevel = existingPath.children;
    });
  });

  return routes;
};

const hierarchicalRoutes = groupRoutesByHierarchy();

const createRoute = (parentPath, route) => {
  const fullPath = parentPath ? `${parentPath}/${route.path}` : route.path;

  let routeInstance;

  if (route.module) {
    if (route.module.prototype?.constructor?.isRouteClass) {
      routeInstance = route.module.getInstance(route.module);
      routeInstance.path = routeInstance.path ?? route.path;
      routeInstance.children = route.children;
      routeInstance.loader = routeInstance.loader.bind(routeInstance);
    } else {
      routeInstance = route.module;
      routeInstance.path = routeInstance.path ?? route.path;
      routeInstance.children = route.children;
    }
  } else {
    routeInstance = route;
  }

  if (routeInstance.index === true) {
    return {
      path: routeInstance.path,
      element: routeInstance.element,
      index: true,
    };
  } else {
    return {
      path: routeInstance.path,
      element: routeInstance.element ?? <Outlet />,
      children: routeInstance.children.map((child) => {
        return createRoute(fullPath, child);
      }),
      loader: routeInstance.loader,
    };
  }
};

let indexRoutes = [];
let processedRoutes = hierarchicalRoutes.reduce((acc, route) => {
  let res = createRoute("", route);
  let rtn = acc;
  if (res) {
    if (res.index) {
      indexRoutes.push(
        Object.fromEntries(
          Object.entries(res).filter(([key]) => key !== "path")
        )
      );
    } else {
      rtn = [...rtn, res];
    }
  }
  return rtn;
}, []);

let routes = [];

if (indexRoutes.length > 1) {
  throw new Error(
    `It looks like you identified more than one route as the 'index' route`
  );
} else if (indexRoutes.length === 1) {
  routes.push(indexRoutes[0]);
}

routes.push({
  path: "/",
  element: <App />,
  children: [
    { path: "*", element: <ErrorPage />, errorElement: <ErrorPage /> },
    ...processedRoutes,
  ],
  errorElement: <ErrorBoundary />,
});

const router = createBrowserRouter(routes);

export default router;
